import { Box, Container, Heading, Text } from '@brand/components';

import { ServicesCarousel } from '@hoa/components/organisms/ServicesCarousel';

import * as prismic from '@prismicio/client';

interface CategoryCarouselProps {
  servicesCarousels: any[];
}

export const CategoryCarousel = ({
  servicesCarousels,
}: CategoryCarouselProps): JSX.Element => {
  const servicesCarouselFormatted = servicesCarousels.map(carousel => {
    const carouselFormatted = carousel.items.map(
      (item: { image: { url: any } }) => {
        const imageUrl = item.image.url;
        return { ...item, image: imageUrl };
      },
    );
    return { ...carousel, items: carouselFormatted };
  });

  const renderCarousels = () => {
    const res = servicesCarouselFormatted.map(carousel => {
      return (
        <Container key={carousel.id} py={10}>
          <Box mb={10}>
            <Heading as="h2" variant="h3" mb={4}>
              {prismic.asText(carousel.primary.main_title)}
            </Heading>
            <Heading as="h3" variant="h4" mb={1}>
              {prismic.asText(carousel.primary.subtitle)}
            </Heading>
            <Text> {prismic.asText(carousel.primary.description)}</Text>
          </Box>
          <ServicesCarousel popularServices={carousel.items} />
        </Container>
      );
    });
    return res;
  };

  return (
    <Box as="section" bg={'gray.100'} className="CarouselGroupSection">
      {renderCarousels()}
    </Box>
  );
};
